<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-16 d-md-block d-none"></div>
            <div class="col col-md-3 d-md-block py-2 font-bold">Название</div>
            <div class="col d-md-block d-none py-2 font-bold">Описание</div>
            <div class="w-20 d-md-block d-none py-2 font-bold">Мин. заказ</div>
            <div class="col d-md-block d-none py-2 font-bold">Доставка</div>
            <div class="col d-md-block d-none py-2 font-bold">Партнер</div>
            <div class="col d-md-block py-2 font-bold flex justify-center" style="max-width: 105px;">Активный</div>
            <div v-if="(archivable || unarchivable) && adminOnly" class="py-2 font-bold flex justify-center" style="min-width: 140px;">Действия</div>
            <div class="w-16 d-md-block d-none py-2 font-bold"></div>
        </div>

        <component :is="isMobile ? 'div': 'draggable'" tag="div" v-model="list">
            <div
                v-for="item in list"
                :key="`${service}-${item.id}`"
                class="flex items-center justify-center py-2 border-t border-gray-300"
            >
                <div class="w-16 d-none d-md-flex justify-center align-center py-1">
                    <div>
                        <CIcon
                            :height="16"
                            :content="cilCursorMove"
                            class="handle" />
                        <span> {{ item.position }}</span>
                    </div>
                </div>

                <div class="col col-md-3 d-md-block py-1">
                    <CLink
                        class="text-purple-700 cursor-pointer hover:underline"
                        :to="`/${service}/${item.id}`">{{ item.title }}</CLink>
                    <CBadge
                        v-if="item.show_in_table_orders"
                        color="info"
                        class="ml-2"
                    >
                        Стол заказов
                    </CBadge>
                </div>

                <div class="col d-md-block d-none truncate py-1" :title="item.description">
                    {{ item.description }}
                </div>

                <div class="w-20 d-md-block d-none truncate py-1">
                    {{ item.min_price }}
                </div>

                <div class="col d-md-block d-none truncate py-1">
                    {{ getMinMaxTimeString(
                        item.delivery_time,
                        item.delivery_time_hour,
                        item.max_delivery_time,
                        item.max_delivery_time_hour,
                    ) }}
                </div>

                <div class="col d-md-block d-none truncate py-1">
                    <CLink v-if="adminOnly" :to="item.partner ? `/partners/${item.partner.id}` : ''">{{ item.partner ? item.partner.title : '' }}</CLink>
                    <template v-else>{{ item.partner ? item.partner.title : '' }}</template>
                </div>

                <div class="col flex justify-center py-1" style="max-width: 105px;">
                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                        {{ item.enabled ? 'Активен' : 'Неактивен' }}
                    </CBadge>
                </div>
                <div v-if="archivable && adminOnly" class="flex justify-center py-1" style="min-width: 140px;">
                    <CButton
                        color="danger"
                        size="sm"
                        :disabled="actionId === item.id"
                        @click="archiveItem(item)"
                    >В архив</CButton>
                </div>
                <div v-if="unarchivable && adminOnly" class="flex justify-center py-1" style="min-width: 140px;">
                    <CButton
                        color="success"
                        size="sm"
                        :disabled="actionId === item.id"
                        @click="unarchiveItem(item)"
                    >Убрать из архива</CButton>
                </div>
                <div class="w-16 d-none d-md-flex justify-center align-center py-1">
                    <CBadge v-if="item.alias">
                        <img
                            src="/integration.png"
                            class="integration_img"
                        />
                    </CBadge>
                </div>
            </div>
        </component>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    import { archiveServiceItem, unarchiveServiceItem } from '@/utils/archive';

    export default {
        components: {
            draggable
        },

        props: {
            data: {
                type: Array,
                default: () => []
            },
            service: {
                type: String,
                default: ''
            },
            archivable: {
                type: Boolean,
                default: false,
            },
            unarchivable: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            cilCursorMove,
            adminOnly: false,
            actionId: null,
        }),

        computed: {
            list: {
                get() {
                    return this.data
                },

                set(v) {
                    const updated = v.map((item, idx) => {
                        item.position = idx + 1
                        return item
                    })

                    this.$emit('update:data', updated)
                }
            },
            isMobile() {
                return window.innerWidth < 768
            }
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
        },

        methods: {
            getMinMaxTimeString (min = 0, hour = 0, maxMin = 0, maxHour = 0) {
                let time = '';
                const minStr = `${min}мин`;
                const hourStr = `${hour}ч`;
                const maxMinStr = `${maxMin}мин`;
                const maxHourStr = `${maxHour}ч`;
                if (hour) {
                    time += hourStr;
                }
                if (min) {
                    time += ` ${minStr}`;
                }
                if (min && !hour && maxMin && !maxHour) {
                    time = `${min} - ${maxMinStr}`;
                }
                if (!min && hour && !maxMin && maxHour) {
                    time = `${hour} - ${maxHourStr}`;
                }
                if (min && !hour && maxMin && maxHour) {
                    time = `${minStr} - ${maxHourStr} ${maxMinStr}`;
                }
                if (min && !hour && !maxMin && maxHour) {
                    time = `${minStr} - ${maxHourStr}`;
                }
                if (min && hour && maxMin && maxHour) {
                    time = `${hourStr} ${min ? minStr : ''} - ${maxHourStr} ${maxHour ? maxMinStr : ''}`;
                }
                if (!min && hour && maxMin && maxHour) {
                    time = `${hourStr} ${min ? minStr : ''} - ${maxHourStr} ${maxHour ? maxMinStr : ''}`;
                }
                return time;
            },
            async archiveItem(item) {
                if (!window.confirm(`Переместить «${item.title}» в архив?`)) {
                    return;
                }

                this.actionId = item.id;
                try {
                    await archiveServiceItem(this.axios, this.service, item);
                    this.$emit('archived', item.id);
                } catch (err) {
                    this.$root.$emit('showError', 'Не удалось переместить в архив.');
                } finally {
                    this.actionId = null;
                }
            },
            async unarchiveItem(item) {
                if (!window.confirm(`Убрать «${item.title}» из архива?`)) {
                    return;
                }

                this.actionId = item.id;
                try {
                    await unarchiveServiceItem(this.axios, this.service, item);
                    this.$emit('unarchived', item.id);
                } catch (err) {
                    this.$root.$emit('showError', 'Не удалось убрать из архива.');
                } finally {
                    this.actionId = null;
                }
            },
        }
    }
</script>
<style scoped>
    .integration_img {
        width: 30px;
        height: 30px;
    }
</style>
